import JSEncrypt from "jsencrypt";

export default {
  toRsa(toast) {
    let RSAEncrypt = new JSEncrypt();
    let publicKey = `-----BEGIN PUBLIC KEY-----
      MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwBvAlZz2oIFtdGGqC2Vr
      TqwXmuJFTPc/l63rEBH3h7Jq7yMQSKkJ5Mgt3KhzMHkxvvLmuad7LJujPzWvyiIi
      siiCS215P1Jvbr9soxttsVQclRASMFDFpfg56veGbVyv5pDut6z/awmfgJ1TQtD5
      vn25IF2AJavg2bmKxn2gAxM6oHf3Sk9cHTlzC+rDiz3jGyoDGTPMMr2WXPjyHQoq
      sCl4d42Gj4vGF1OmzDDwCXwsFF9YREP3HQB0tISS5PwMC1H8mQtyz456rqnxPdi6
      HHuWU5Nin+q6fEmrgzpqqdLZ6zHo25FD/YM+wvCa0nCUNsjir9PQyh07zlA3krHf
      LwIDAQAB
      -----END PUBLIC KEY-----`;
    RSAEncrypt.setPublicKey(publicKey);
    return RSAEncrypt.encrypt(toast);
    // return  Buffer.from(encryptedPass).toString("base64");

  }

};
